module.exports = __webpack_public_path__ + "img/Dry_Flower.d962c7ef.svg";